import React from "react";
import { useSearchParams } from "react-router-dom";
import FinancingCalculator from "../components/FinancingCalculator";
import api from "../lib/api";
import { Wallet, ShieldCheck, Percent, FileSignature } from "lucide-react";

const FEATURES = [
  { icon: Percent, title: "Faire Konditionen", desc: "Attraktive Zinssätze unserer österreichischen Partnerbanken." },
  { icon: ShieldCheck, title: "Sichere Abwicklung", desc: "Transparente Verträge, keine versteckten Kosten." },
  { icon: FileSignature, title: "Schnelle Zusage", desc: "Online-Vorab-Check und Genehmigung innerhalb 24h." },
  { icon: Wallet, title: "Flexible Laufzeit", desc: "12 bis 84 Monate – passgenau für Ihr Budget." },
];

const Financing = () => {
  const [params] = useSearchParams();
  const vehicleId = params.get("vehicle");
  const [vehicle, setVehicle] = React.useState(null);

  React.useEffect(() => {
    if (!vehicleId) return;
    api.get(`/vehicles/${vehicleId}`).then((r) => setVehicle(r.data)).catch(() => {});
  }, [vehicleId]);

  return (
    <div className="bg-[var(--na-bg)] pt-12 pb-24" data-testid="financing-page">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="text-[11px] uppercase tracking-[0.3em] text-[var(--na-red)] font-semibold mb-3">
          Finanzierung
        </p>
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tighter leading-[1.05]">
          Ihr Wunschfahrzeug, <span className="silver-gradient-text">monatlich finanziert.</span>
        </h1>
        <p className="text-zinc-300 mt-5 max-w-2xl leading-relaxed">
          Berechnen Sie Ihre individuelle Rate – einfach und in Sekunden. Anschließend erhalten Sie ein
          unverbindliches Finanzierungsangebot unserer Partnerbank.
        </p>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-10 mb-14">
          {FEATURES.map((f) => (
            <div key={f.title} className="bg-[#2E2E3C] border border-silver-soft rounded-2xl p-5">
              <div className="w-9 h-9 rounded-xl bg-[var(--na-red)]/15 text-[var(--na-red)] flex items-center justify-center mb-3">
                <f.icon className="w-4 h-4" strokeWidth={1.7} />
              </div>
              <p className="font-display font-semibold text-white text-sm">{f.title}</p>
              <p className="text-xs text-zinc-400 mt-1.5 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>

        <FinancingCalculator initialVehicle={vehicle} />
      </div>
    </div>
  );
};

export default Financing;
